"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JcbCard = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var JcbCard = function JcbCard(props) {
  return /*#__PURE__*/_react.default.createElement(_SvgIcon.default, _extends({
    viewBox: "0 0 23 18"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M23 14.3409C23 16.3366 21.3973 17.9617 19.4291 17.9617H0V3.62086C0 1.62511 1.60269 0 3.5709 0H23V14.3409Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.6715 10.6642H18.1477C18.1899 10.6642 18.2883 10.6499 18.3305 10.6499C18.6116 10.5929 18.8506 10.3363 18.8506 9.97992C18.8506 9.6378 18.6116 9.3812 18.3305 9.30992C18.2883 9.29567 18.2039 9.29567 18.1477 9.29567H16.6715V10.6642Z",
    fill: "url(#paint0_linear_7083_1430)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.979 1.21289C16.5731 1.21289 15.4203 2.36757 15.4203 3.80736V6.50162H19.0334C19.1177 6.50162 19.2162 6.50162 19.2864 6.51588C20.1019 6.55864 20.7064 6.9863 20.7064 7.72758C20.7064 8.31205 20.2987 8.81099 19.5395 8.91077V8.93929C20.369 8.99631 21.0016 9.46673 21.0016 10.1938C21.0016 10.9778 20.2987 11.491 19.3708 11.491H15.4062V16.7655H19.1599C20.5658 16.7655 21.7186 15.6108 21.7186 14.171V1.21289H17.979Z",
    fill: "url(#paint1_linear_7083_1430)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M18.6679 7.89864C18.6679 7.55652 18.4289 7.32843 18.1477 7.28567C18.1196 7.28567 18.0493 7.27141 18.0071 7.27141H16.6715V8.52588H18.0071C18.0493 8.52588 18.1336 8.52588 18.1477 8.51162C18.4289 8.46886 18.6679 8.24077 18.6679 7.89864Z",
    fill: "url(#paint2_linear_7083_1430)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M3.83836 1.21289C2.4325 1.21289 1.27968 2.36757 1.27968 3.80736V10.208C1.99668 10.5644 2.74179 10.7925 3.4869 10.7925C4.37259 10.7925 4.85059 10.2508 4.85059 9.5095V6.48737H7.04374V9.49524C7.04374 10.6642 6.32675 11.6193 3.8946 11.6193C2.41844 11.6193 1.26562 11.2914 1.26562 11.2914V16.7512H5.01929C6.42516 16.7512 7.57797 15.5965 7.57797 14.1567V1.21289H3.83836Z",
    fill: "url(#paint3_linear_7083_1430)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.9102 1.21289C9.50437 1.21289 8.35156 2.36757 8.35156 3.80736V7.20013C8.99826 6.64418 10.123 6.28779 11.9365 6.37332C12.9066 6.41609 13.9469 6.68694 13.9469 6.68694V7.7846C13.4267 7.51375 12.8082 7.27141 12.0068 7.21439C10.6291 7.1146 9.79961 7.79886 9.79961 8.99631C9.79961 10.208 10.6291 10.8923 12.0068 10.7782C12.8082 10.7212 13.4267 10.4646 13.9469 10.208V11.3057C13.9469 11.3057 12.9206 11.5765 11.9365 11.6193C10.123 11.7048 8.99826 11.3484 8.35156 10.7925V16.7797H12.1052C13.5111 16.7797 14.6639 15.625 14.6639 14.1853V1.21289H10.9102Z",
    fill: "url(#paint4_linear_7083_1430)"
  }), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "paint0_linear_7083_1430",
    x1: "15.4179",
    y1: "7.89683",
    x2: "21.7357",
    y2: "7.89683",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "0.2285",
    stopColor: "#00873F"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "0.7433",
    stopColor: "#40A737"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "1",
    stopColor: "#5CB531"
  })), /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "paint1_linear_7083_1430",
    x1: "15.4179",
    y1: "7.89683",
    x2: "21.7357",
    y2: "7.89683",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "0.2285",
    stopColor: "#00873F"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "0.7433",
    stopColor: "#40A737"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "1",
    stopColor: "#5CB531"
  })), /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "paint2_linear_7083_1430",
    x1: "15.4179",
    y1: "7.89683",
    x2: "21.7357",
    y2: "7.89683",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "0.2285",
    stopColor: "#00873F"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "0.7433",
    stopColor: "#40A737"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "1",
    stopColor: "#5CB531"
  })), /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "paint3_linear_7083_1430",
    x1: "1.27671",
    y1: "8.98295",
    x2: "7.69211",
    y2: "8.98295",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#1F286F"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "0.4751",
    stopColor: "#004E94"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "0.8261",
    stopColor: "#0066B1"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "1",
    stopColor: "#006FBC"
  })), /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "paint4_linear_7083_1430",
    x1: "8.31521",
    y1: "8.98295",
    x2: "14.5461",
    y2: "8.98295",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#6C2C2F"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "0.1735",
    stopColor: "#882730"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "0.5731",
    stopColor: "#BE1833"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "0.8585",
    stopColor: "#DC0436"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "1",
    stopColor: "#E60039"
  }))));
};
exports.JcbCard = JcbCard;